(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('ScoreDetailController', ScoreDetailController);

    ScoreDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Score'];

    function ScoreDetailController($scope, $rootScope, $stateParams, previousState, entity, Score) {
        var vm = this;

        vm.score = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('liverunApp:scoreUpdate', function(event, result) {
            vm.score = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
